// import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./components";
import { mainRoutes } from "./pages/main.route";
// import App from "./App";
// import ErrorBoundary from "src/components/ErrorBoundary/ErrorBoundary";
// import reportWebVitals from "./reportWebVitals";
// import "./styles/main.css";
// import "normalize.css";
// import "the-new-css-reset/css/reset.css";
import "./service-worker-registration";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  // <StrictMode>
  <BrowserRouter>
    <Routes entryRoutes={mainRoutes} />
  </BrowserRouter>
  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
